<template>
  <div>
    <div v-if="dataReady" class="row gutter-sm q-mb-md">
      <component
        v-for="component in statisticsComponents"
        :key="component"
        :hasRedirect="true"
        v-bind:is="registeredComponent(component)"
        class="col-md-4 col-sm-12 col-xs-12 q-pa-sm"
      ></component>
    </div>
  </div>
</template>

<script>
import statisticsOverview from '../statistics/statisticsOverview';

export default {
  mixins: [statisticsOverview],
  computed: {
    statisticsComponents() {
      return this.componentsByRights.dashboard;
    },
  },
};
</script>
